import { trackEvent, trackEcommerce } from 'dibs-tracking';
import get from 'lodash.get';

const trackInteraction = ({ action, label }) => {
    trackEvent({
        category: 'promo interaction',
        action,
        label,
        value: 0,
    });
};

export const trackInitialDisplay = ({ itemsReturned, actionLabel }) => {
    trackInteraction({
        action: `${actionLabel} items displayed`,
        label: itemsReturned,
    });
};

export const trackArrowClick = ({ direction, actionLabel }) => {
    trackInteraction({
        action: `${actionLabel} items arrow clicked`,
        label: direction,
    });
};

export const trackItemClick = ({ actionLabel }) => {
    trackInteraction({
        action: `${actionLabel} items item clicked`,
        label: 'none',
    });
};

export const trackCarouselItems = ({ type, items, startIndex, variant, actionLabel }) => {
    trackEcommerce({
        type,
        actionField: { list: `${actionLabel} carousel` },
        products: items.map((item, index) => ({
            brand: get(item, 'seller.serviceId'),
            category: item.browseUrl,
            categoryCode: item.categoryCode,
            id: item.serviceId,
            variant,
            name: item.title,
            list: `${actionLabel} carousel`,
            dimension83: item.contemporaryTrackingString,
            position: startIndex + index,
            url: item.link || '',
        })),
    });
};
